/**
 * «Глазик» на карточке каталога: открывает 3D-предпросмотр. Мышью — виден при наведении на
 * карточку (родитель карточки помечен классом `group`). На планшете и телефоне наведения нет,
 * поэтому там глазик виден всегда и крупнее — под палец (`pointer-coarse`). Стоит рядом с
 * кнопкой карточки, а не внутри неё: кнопка в кнопке — недопустимая разметка.
 */
import { UIKit } from "@/shared/ui";

export const PreviewEyeButton = ({
	onClick,
	inline = false,
}: {
	onClick: () => void;
	/**
	 * В строке списка — обычный элемент раскладки справа, а не поверх: в узкой строке глазик
	 * в углу наезжал бы на название. По умолчанию — в правом верхнем углу карточки.
	 */
	inline?: boolean;
}) => (
	<button
		type="button"
		title="Предпросмотр 3D"
		aria-label="Предпросмотр 3D"
		className={`${inline ? "relative shrink-0" : "absolute top-1.5 right-1.5"} flex size-5 items-center justify-center rounded-md bg-white/90 text-ink opacity-0 shadow-md ring-1 ring-black/5 backdrop-blur-sm transition-all duration-150 group-hover:opacity-100 hover:scale-110 hover:text-accent focus-visible:opacity-100 pointer-coarse:size-7 pointer-coarse:opacity-100`}
		onClick={(event) => {
			event.stopPropagation();
			onClick();
		}}
	>
		<UIKit.IconEye />
	</button>
);
